<div class="relative">
  @if (label()) {
    <label
      [for]="label()"
      class="absolute text-xs -top-2 left-3 z-10 bg-white px-1 rounded-md transition duration-300 font-medium text-neutral-700">
      {{ label() }}
    </label>
  }
  <div class="relative">
    <input
      [id]="label()"
      type="date"
      [value]="inputValue"
      [max]="max()"
      [min]="min()"
      (change)="onDateChange($event)"
      [disabled]="isDisabled"
      [class.opacity-50]="isDisabled"
      [class.cursor-not-allowed]="isDisabled"
      class="h-full py-[0.42rem] px-3 block w-full border border-neutral-700 rounded-lg sm:text-sm focus:ring-0 focus:outline-primary-80 placeholder:text-neutral-700" />
  </div>
</div>
